export default {
      id: "app-store-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#app-store",
      toString: function () {
        return this.url;
      }
    }